@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.life.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.life.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_830_199_053)
internal val Res.drawable.ic_barbecue_20: DrawableResource by lazy {
      DrawableResource("drawable:ic_barbecue_20", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_barbecue_20.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-840_201_508)
internal val Res.drawable.ic_book_36: DrawableResource by lazy {
      DrawableResource("drawable:ic_book_36", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_book_36.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_993_278_847)
internal val Res.drawable.ic_bottle_20: DrawableResource by lazy {
      DrawableResource("drawable:ic_bottle_20", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bottle_20.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_261_067_585)
internal val Res.drawable.ic_chat_36: DrawableResource by lazy {
      DrawableResource("drawable:ic_chat_36", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_chat_36.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-893_026_226)
internal val Res.drawable.ic_checkmark_checked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_checked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_462_582_460)
internal val Res.drawable.ic_checkmark_unchecked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_unchecked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_unchecked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-813_328_834)
internal val Res.drawable.ic_clipboard_20: DrawableResource by lazy {
      DrawableResource("drawable:ic_clipboard_20", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_clipboard_20.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_916_854_059)
internal val Res.drawable.ic_clipboard_36: DrawableResource by lazy {
      DrawableResource("drawable:ic_clipboard_36", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_clipboard_36.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_120_882_383)
internal val Res.drawable.ic_compass_20: DrawableResource by lazy {
      DrawableResource("drawable:ic_compass_20", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_compass_20.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_372_898_403)
internal val Res.drawable.ic_football_boots_20: DrawableResource by lazy {
      DrawableResource("drawable:ic_football_boots_20", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_football_boots_20.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_691_535_620)
internal val Res.drawable.ic_splash: DrawableResource by lazy {
      DrawableResource("drawable:ic_splash", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_splash.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_068_899_413)
internal val Res.drawable.ic_time_6: DrawableResource by lazy {
      DrawableResource("drawable:ic_time_6", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_time_6.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_641_535_461)
internal val Res.drawable.ic_user_36: DrawableResource by lazy {
      DrawableResource("drawable:ic_user_36", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_user_36.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_barbecue_20", Res.drawable.ic_barbecue_20)
  map.put("ic_book_36", Res.drawable.ic_book_36)
  map.put("ic_bottle_20", Res.drawable.ic_bottle_20)
  map.put("ic_chat_36", Res.drawable.ic_chat_36)
  map.put("ic_checkmark_checked", Res.drawable.ic_checkmark_checked)
  map.put("ic_checkmark_unchecked", Res.drawable.ic_checkmark_unchecked)
  map.put("ic_clipboard_20", Res.drawable.ic_clipboard_20)
  map.put("ic_clipboard_36", Res.drawable.ic_clipboard_36)
  map.put("ic_compass_20", Res.drawable.ic_compass_20)
  map.put("ic_football_boots_20", Res.drawable.ic_football_boots_20)
  map.put("ic_splash", Res.drawable.ic_splash)
  map.put("ic_time_6", Res.drawable.ic_time_6)
  map.put("ic_user_36", Res.drawable.ic_user_36)
}
